<template>
  <el-form class="rich-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="wholeLine">
      <template slot="label">
        整行宽度
      </template>
      <el-checkbox v-model="control.wholeLine"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "rich-control",
  props: {
    control: Object
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.rich-control {
}
</style>
